import { Button, TOUCH } from "@nymbl/nos2-rules";
import { Link } from "@tanstack/react-router";
import { CalendarPlus, Clock, ReceiptText } from "lucide-react";
import { TodayChip } from "@/components/time/TodayChip";
import { isPageBuilt, PAGE_HREFS } from "@/lib/features";
import { formatDayCount } from "@/lib/pto/days";

interface HomeActionsProps {
  /** Opens Log time; the dialog searches the person's tasks itself, so it is always enabled. */
  onLogTime: () => void;
  /** Vacation days left this year; shown on the PTO request button above 0, null until loaded. */
  vacationLeft?: number | null;
  /** The server switch EXPENSES_ENABLED. */
  expensesEnabled?: boolean;
}

/** Log time always; PTO request (opens the request dialog) and Expense only once those pages are built (in the nav). */
export function HomeActions({
  onLogTime,
  vacationLeft = null,
  expensesEnabled = false,
}: HomeActionsProps) {
  const left =
    vacationLeft !== null && vacationLeft > 0 ? `${formatDayCount(vacationLeft)} left` : null;
  return (
    <>
      <TodayChip hideOnPhone />
      <Button className={TOUCH} onClick={onLogTime}>
        <Clock aria-hidden="true" />
        Log time
      </Button>
      {isPageBuilt(PAGE_HREFS.pto) && (
        <Button asChild variant="outline" className={TOUCH}>
          <Link
            to="/dashboard/pto"
            search={{ request: "new" }}
            aria-label={left ? `PTO request, ${left}` : "PTO request"}
          >
            <CalendarPlus aria-hidden="true" />
            PTO request
            {left && (
              <span className="rounded-full bg-info-bg px-2 py-0.5 text-xs font-semibold text-info">
                {left}
              </span>
            )}
          </Link>
        </Button>
      )}
      {expensesEnabled && isPageBuilt(PAGE_HREFS.expenses) && (
        <Button asChild variant="outline" className={TOUCH}>
          <Link to="/dashboard/expenses" search={{ expense: "new" }} aria-label="Expense">
            <ReceiptText aria-hidden="true" />
            Expense
          </Link>
        </Button>
      )}
    </>
  );
}
